import type { OpportunityListType, OpportunityListOption } from "../types";

export const isOpportunityListNameLongEnough = (name: OpportunityListType["friendlyName"]) => {
    // TODO: Extract to constant
    return name.trim().length >= 1;
};

export const opportunityListHasId = (id: string) => (list: OpportunityListType) => {
    return list.opportunityListId === id;
};

const opportunityListDoesNotHaveId = (id: string) => (list: OpportunityListType) => {
    return list.opportunityListId !== id;
};

export const opportunityListOptionNameIncludes = (name: string) => (list: OpportunityListOption) => {
    return list.name.toLowerCase().includes(name.toLowerCase());
};

/**
 * Sorts given opportunity lists by name alphabetically
 * @param lists
 */
export const sortOpportunityListsByFriendlyName = (lists: ReadonlyArray<OpportunityListType>) => {
    return lists.slice().sort((a, b) => {
        return a.friendlyName.localeCompare(b.friendlyName);
    });
};

export const reduceToListOfOpportunities = (lists: OpportunityListType[]) => {
    return lists.reduce((opportunities: string[], list: OpportunityListType) => {
        return opportunities.concat(list.opportunities);
    }, []);
};

export const updateOpportunityLists = (lists: OpportunityListType[], update: OpportunityListType) => {
    const matchesUpdate = opportunityListHasId(update.opportunityListId);

    return lists.map((list) => {
        if (matchesUpdate(list)) {
            return update;
        }

        return list;
    });
};

export const removeFromOpportunityLists = (
    lists: OpportunityListType[],
    listId: OpportunityListType["opportunityListId"],
) => {
    return lists.filter(opportunityListDoesNotHaveId(listId));
};

export const removeWebsitesFromListOpportunities = (
    list: OpportunityListType,
    websites: string[],
): OpportunityListType => {
    return {
        ...list,
        opportunities: list.opportunities.filter((opportunity) => {
            return !websites.includes(opportunity);
        }),
    };
};
